<template>
  <div class="mt-7">
    <v-row class="mx-9" v-for="(option, i) in userFilterOptions" :key="i">
      <v-select
        filled
        :items="option.items"
        :label="option.label"
        class="pt-0"
        color="secondary"
        v-model="filterParams[option.model]"
      ></v-select>
    </v-row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import FilterParams from '@/mixins/FilterParams';

export default {
  mixins: [FilterParams],
  computed: {
    ...mapGetters({
      userFilterOptions: 'account/getUserFilterOptions',
    }),
  },
};
</script>
